import { registerComponent } from '@gig/magic-common';
import StickyTooltipComponent from './sticky-tooltip.vue.js';

var StickyTooltip = registerComponent(StickyTooltipComponent);

export { StickyTooltip };
